import {dateTime} from "services/date";
import {LinkedAccount} from "../../../types/LinkedAccount";

/**
 * Transform the given linked account by deserializing object properties
 *
 * @internal
 * @param linkedAccount
 */
export default function deserializeLinkedAccount(linkedAccount: any): LinkedAccount {
    linkedAccount.created_at = dateTime(linkedAccount.created_at)
    linkedAccount.updated_at = dateTime(linkedAccount.updated_at)

    return linkedAccount;
}